<template>
    <div v-test-id="{ field: 'lacuna', action: 'main' }" :class="classList">
        <div class="app-lacuna__content">
            <div v-if="findSlot('icon')" class="app-lacuna__icon">
                <slot name="icon" />
            </div>
            <div v-else-if="icon" class="app-lacuna__icon">
                <v-icon :color="iconColour" :size="iconSize">{{ getIcon(icon, iconPrefix) }}</v-icon>
            </div>

            <div v-if="findSlot('title')" class="app-lacuna__title">
                <slot name="title" />
            </div>
            <div v-else-if="title" class="app-lacuna__title">
                <span>{{ title }}</span>
            </div>
            <div v-else-if="!title" class="mt-2" />

            <div v-if="findSlot('text')" class="app-lacuna__text" :class="textClassList">
                <slot name="text" />
            </div>
            <div v-else-if="text" class="app-lacuna__text" :class="textClassList">
                <span>{{ text }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppLacuna',
    props: {
        icon: {
            type: String,
            default: null
        },
        iconPrefix: {
            type: String,
            default: 'fad'
        },
        title: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: null
        },
        textClassList: {
            type: String,
            default: null
        },
        iconColour: {
            type: String,
            default: 'primaryLight'
        },
        iconSize: {
            type: String,
            default: '10rem'
        }
    },
    computed: {
        classList() {
            let classList = ['app-lacuna'];

            return classList.join(' ');
        }
    }
};
</script>

<style lang="scss" scoped>
.app-lacuna {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    color: var(--v-primaryLight-base);
    &__content {
        text-align: center;
        padding: 1.5rem;
    }
    &__title {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.5rem;
        color: var(--v-primaryText-base);
    }
    &__text {
        color: var(--v-primaryText-base);
        font-size: 1rem;
        margin-top: 0.3rem;
    }
}
</style>
